export default __webpack_public_path__ + "static/media/english-to-dutch-screenshot-05.8a2d2ac9.png";